import { NgModule }             from '@angular/core';
import { FormsModule }          from '@angular/forms';
import { CommonModule }         from '@angular/common';
import { CommonToolModule }     from '../common/common-tool.module';
import { MobileMainComponent }  from './mobile-main.component';
import { TransReportComponent } from './trans-report.component';
import { SearchCargoComponent } from './search-cargo.component';
import { MobileNoticeComponent } from './notice.component';
import { AppRoutingModule }     from '../app-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    CommonToolModule    //共通部品をcomponentとしてimportするとエラーになる、module化してimportする
  ],
  declarations: [
    MobileMainComponent,
    TransReportComponent,
    SearchCargoComponent,
    MobileNoticeComponent
  ],
  providers: [  ]
})
export class MobileModule {}



// WEBPACK FOOTER //
// ./src/app/mobile/mobile.module.ts